// Vendors
import $ from 'jquery';

$(document).ready(() => {
  const { endpoint, nonce } = window.uConfig;
  const $form = { newsletter: $('#newsletter-form') };
  const $formBtn = { newsletter: $('#newsletter-form__submit') };
  let formData = {};

  // Inject user email into input field, if available (set in footer-newsletter.js).
  const localStorageUserEmail = localStorage.getItem('newsletter-user-email');

  if (localStorageUserEmail) {
    $('.form__input[name="email"]').val(localStorageUserEmail);
  }

  // Form event listeners.
  $(document)
    .on('click', '#newsletter-form__submit', (event) =>
      processSubscribeUser(event)
    )
    .on('submit', '#newsletter-form', (event) => processSubscribeUser(event));

  // pre-submit error handling
  onBlurHandleError($('*[required]'));

  // form submit
  function processSubscribeUser(event) {
    event.preventDefault();

    const method = $(event.currentTarget).data('method');

    $('*[required]').each(function () {
      checkFields($(this));
    });

    if ($('#newsletter-form .form__field--error').length > 0) {
      $('html').animate(
        {
          scrollTop: $('#newsletter-form .form__field--error').offset().top - 75
        },
        1000
      );
      return;
    }

    // Check what fields actually have updated values, compared to `usermeta`.
    formData = Object.values($form[method].serializeArray()).reduce(
      (acc, current) => {
        return {
          ...acc,
          [current['name']]: current['value']
        };
      },
      {}
    );

    $formBtn[method].attr('disabled', 'disabled');
    $form[method].addClass('form--loading');

    $('html').animate(
      {
        scrollTop: $('#newsletter-form').offset().top - 75
      },
      1000
    );

    makeAjaxCall(formData, method);
  }

  function makeAjaxCall(data, method) {
    $.ajax({
      url: endpoint,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'wl_subscribe_user',
        method,
        nonce,
        ...data
      },
      success: ({ success, data: { error, updated, method, message } }) => {
        // Only happens with invalid nonce or invalid user id:
        if (!success) {
          $form['newsletter'].prepend(
            `<div class="grid__col-xs-12">
                <div class="notice notice--red">
                  <div class="notice__type">
                    <strong class="notice__title">Error</strong>
                  </div>
                  <div class="notice__message">
                    <div class="u--text-align-center-md-max">There was an error subscribing to our newsletter. Please try again.</div>
                  </div>
                </div>
              </div>
            `
          );

          $formBtn[method].removeAttr('disabled');
          $form[method].removeClass('form--loading');
          return;
        }

        // Remove notices.
        $form['newsletter'].find('.notice').remove();
        writeNotice($form['newsletter'], message);
        $formBtn[method].removeAttr('disabled');
        $form[method].removeClass('form--loading');

        if (localStorageUserEmail) {
          localStorage.removeItem('newsletter-user-email');
        }
      },
      error: function () {
        $form['newsletter'].prepend(
          `<div class="grid__col-xs-12">
                <div class="notice notice--red">
                  <div class="notice__type">
                    <strong class="notice__title">Error</strong>
                  </div>
                  <div class="notice__message">
                    <div class="u--text-align-center-md-max">There was an issue, please try again.</div>
                  </div>
                </div>
              </div>
            `
        );

        $formBtn[method].removeAttr('disabled');
        $form[method].removeClass('form--loading');
        return;
      }
    });
  }

  function writeNotice($formElement, updatedFields) {
    // Write and append notice.
    $formElement.prepend(
      `<div class="grid__col-xs-12">
        <div class="notice notice--green">
          <div class="notice__type"> <strong class="notice__title">Success</strong></div><div class="notice__message">
          <div class="u--text-align-center-md-max">You have successfully subscribed to our newsletter. We\'ll be in touch soon!</div>
        </div>
      </div>`
    );
  }

  // error handling
  function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function isError(el, name) {
    el.next('.form__help').text(`${name} is required`);
    el.parents('.form__field').addClass('form__field--error');
    return false;
  }

  function isErrorEmail(el, name) {
    el.next('.form__help').text(`${name} must be valid`);
    el.parents('.form__field').addClass('form__field--error');
    return false;
  }

  function isValid(el) {
    el.next('.form__help').text('');
    el.parents('.form__field').removeClass('form__field--error');
  }

  function checkFields(el) {
    const name = el.prev('.form__label').text().slice(0, -1);
    const $id = el.attr('id');
    const $val = el.val();

    if (!$val.trim()) {
      isError(el, name);
    } else if ($id === 'email') {
      if (!emailIsValid($val)) {
        isErrorEmail(el, name);
      } else {
        isValid(el);
      }
    } else if ($id === 'pass2') {
      passMatch();
    } else {
      isValid(el);
    }
  }

  function onBlurHandleError(requiredEls) {
    requiredEls.each(function () {
      $(this).on('blur', function () {
        checkFields($(this));
      });
    });
  }
});
